import { supabase } from '@/core/database/supabase';
import type { UtilitySystem, UtilityComponent } from '../../types/utility.types';

export const utilityDetailService = {
  async getSystemDetail(id: string): Promise<UtilitySystem | null> {
    const { data, error } = await supabase
      .from('utility_systems')
      .select(`
        id,
        company_id,
        project_id,
        zone_id,
        system_code:code,
        system_name:name,
        system_type:utility_type,
        status_code,
        description:notes,
        created_at,
        updated_at,
        project:projects(id, name),
        zone:project_zones(id, name:zone_name)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  },

  async getSystemComponents(systemId: string): Promise<UtilityComponent[]> {
    const { data, error } = await supabase
      .from('utility_components')
      .select('*')
      .eq('system_id', systemId)
      .order('code', { ascending: true });

    if (error) throw error;
    return data || [];
  }
};
